export const AuthRoles = {
  SuperAdmin: 'WsAuthUserManager',
  Press: 'AddettoStampaRisultati'
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function hasRole(userData: any, role: string): boolean {
  const r: unknown = userData?.role;
  if (Array.isArray(r)) {
    return (r as string[]).includes(role);
  }
  if (typeof r === 'string') {
    return r === role;
  }
  return false;
}
